module.exports = __webpack_public_path__ + "static/media/privacy.e13e2eda.md";